module.exports = __webpack_public_path__ + "f550369cc76b13a1469250a41459d68d.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/BRCA-Exchange-tall-tranparent.png
// module id = 1335
// module chunks = 0